<nav class="navigation">
  <div class="nav-container" role="navigation">
    <app-dropdown></app-dropdown>
    <ul class="nav">
      <li class="nav-item">
        <a routerLink="apresentacao" class="link">Apresentação</a>
      </li>
      <li class="nav-item">
        <a routerLink="cursos" class="link">Todos os Cursos</a>
      </li>
      <li class="nav-item">
        <a routerLink="faq" class="link">Perguntas Frequentes</a>
      </li>
      <!-- <li class="nav-item">
        <a target="_blank" href="https://monp.abdi.com.br" class="link">Painel Monitor de Profissões</a>
      </li> -->
      <!-- Utilizado na consulta pública -->
      <!-- <li class="nav-item">
        <a class="link cursor-pointer" (click)="reloadPage()">Consulta Pública</a>
      </li> -->
    </ul>

    <form class="searchbox rounded-pill bg-color-white border-white-2" role="searchbox" aria-label="pesquisarNoCatalogo"
      [formGroup]="formularioBarraPesquisa" (ngSubmit)="onPesquisar()">
      <label class="searchbox-hidden" for="catalogo-search">Buscar no portal</label>

      <input type="search" class="searchbox-input bg-color-white color-dark" placeholder="O que você procura?"
        id="catalogo-search" formControlName="stringBusca" />

      <button name="buscar" type="submit" value="busca" aria-label="buscarNoCatalogo" class="btn searchbox-button">
        pesquisar
      </button>
    </form>
  </div>

  <!-- dropdown -->
</nav>